import { Trash } from 'react-bootstrap-icons';
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useState } from 'react';

export const DeleteButton = (props: { onClick: () => void }) => {
  const [open, setOpen] = useState(false)

  return <>
    <OverlayTrigger overlay={<Tooltip>Delete Item</Tooltip>}>
      <Button
        variant="outline-danger"
        size="sm"
        onClick={() => setOpen(true)}>
        <Trash />
      </Button>
    </OverlayTrigger>
    <Modal show={open} onHide={() => setOpen(false)}>
      <Modal.Header>Confirm Delete</Modal.Header>
      <Modal.Footer>
          <Button onClick={() => {props.onClick(); setOpen(false)}}>Confirm</Button>
          <Button 
            variant="outline-secondary"
            onClick={() => setOpen(false)}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  </>
}